export const fallbackString = (
  value: string | undefined | null,
  placeholder = '-'
): string => {
  return value && value.trim() !== '' ? value : placeholder
}
